import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from "./locales/en/translation.json";
import translationES from "./locales/es/translation.json";
import LanguageDetector from "i18next-browser-languagedetector";
import i18next from "i18next";

const resources = {
    en: {
        translation: translationEN,
    },
    es: {
        translation: translationES,
    },
};

i18next
    .use(initReactI18next)
    .use(LanguageDetector)
    .init({
        resources,
        detection: {
            order: ["navigator"],
        },
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;
export { i18next };
